<header>
  <div class="header-text">
    <span class="title">{{ title() }}</span>
    @if (statusText()) {
      <span
        class="status-chip"
        [class.active]="statusVariant() === 'active'"
        [class.inactive]="statusVariant() === 'inactive'"
        [class.warning]="statusVariant() === 'warning'">
        {{ statusText() }}
      </span>
    }
  </div>

  <div class="action-buttons">
    @if (expandable()) {
      <button
        type="button"
        class="action-button"
        (click)="onToggle()"
        aria-label="Expandir o contraer"
        [attr.aria-expanded]="expanded()">
        <span
          class="material-symbols-rounded"
          appNoTranslateMaterialSymbols
          [class.expanded]="expanded()">
          keyboard_arrow_down
        </span>
      </button>
    }

    @if (closeable()) {
      <button
        type="button"
        class="action-button"
        (click)="onClose()"
        aria-label="Cerrar">
        <span class="material-symbols-rounded" appNoTranslateMaterialSymbols>
          close
        </span>
      </button>
    }
  </div>
</header>

<div [@expandCollapse]="animationState()">
  <ng-content />
</div>
